<script>
export default {
  name: "DidoMillesimeTabDocumentations",
};
</script>

<script setup>
import DidoResourcesPagination from "../../commons/resources-pagination/Pagination.vue";

// define Props
const props = defineProps({
  apiUrl: { type: String, required: true },
  documentations: { type: Object, required: true },
});
</script>

<template>
  <div>
    <DidoResourcesPagination
      :api-url="props.apiUrl"
      :resources="props.documentations"
      type="documentations"
    />
  </div>
</template>
